/**
 * Local Database - Sync Operations
 *
 * Functions for syncing local data with the server.
 */

import { isElectron, getElectronWindow } from './store'

import type { SyncStatus } from './types'

/**
 * Get sync status
 */
export async function getSyncStatus(orgId: string): Promise<SyncStatus> {
  if (isElectron) {
    return getElectronWindow().electronAPI.db.getSyncStatus(orgId)
  }

  return {
    pendingChanges: 0,
    lastSyncAt: null,
    isOnline: typeof navigator !== 'undefined' ? navigator.onLine : /* v8 ignore next */ true,
    isSyncing: false,
  }
}

/**
 * Trigger sync with server
 */
export async function triggerSync(orgId: string): Promise<void> {
  if (isElectron) {
    return getElectronWindow().electronAPI.db.sync(orgId)
  }

  // Web fallback - sync handled by API services
}
